module.exports = __webpack_public_path__ + "img/lens-174-plus-08.8b7f5336.png";